/*
 * @Descripttion: 设备列表
 * @version: 
 * @Author: wl
 * @Date: 2020-06-17 11:06:20
 * @LastEditors: wl
 * @LastEditTime: 2020-06-17 11:16:51
 */ 

import axios from '../axios'


//人员审核、
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/admin/service/getCapabilitylayer_deviceList',
        method: 'post',
        data
    })
}
//人脸查询
export const finddetailPage = (data) => {
    return axios({
        url: '/admin/service/sys_device_detail',
        method: 'post',
        data
    })
}
//senseLink数据查询
export const senseLink_device_list = (data) => {
    return axios({
        url: '/admin/service/senseLink_device_list',
        method: 'post',
        data
    })
}
// 更改设备是否远程开门
export const open_door_control = (data) => {
    return axios({
        url: '/admin/service/open_door_control',
        method: 'post',
        data
    })
}
//充电桩
// 
export const gsm_chargingPile_getDevice = (data) => {
    return axios({
        url: '/admin/service/gsm_chargingPile_getDevice',
        method: 'post',
        data
    })
}
// 充电桩添加经纬度
export const gsm_chargingPile_edit = (data) => {
    return axios({
        url: '/admin/service/gsm_chargingPile_edit',
        method: 'post',
        data
    })
}
// 修改设备的经纬度
export const sys_device_edit_local = (data) => {
    return axios({
        url: '/admin/service/sys_device_edit_local',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/resource.js